import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReviewerRoleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 14,
	viewBox: "0 0 19 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.37012 6.66667C7.37012 5.74619 8.11631 5 9.03679 5C9.95726 5 10.7035 5.74619 10.7035 6.66667C10.7035 7.58714 9.95726 8.33333 9.03679 8.33333C8.11631 8.33333 7.37012 7.58714 7.37012 6.66667Z",
		fill: "#EAAA08"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.03679 0C6.65207 0 4.70792 1.05393 3.26742 2.25619C1.82888 3.45682 0.842598 4.84524 0.348643 5.62737L0.328572 5.65903C0.230555 5.81331 0.103293 6.01363 0.038959 6.29431C-0.0129863 6.52093 -0.0129863 6.8124 0.038959 7.03903C0.103293 7.3197 0.230554 7.52002 0.328571 7.6743L0.348643 7.70596C0.842598 8.48809 1.82888 9.87652 3.26742 11.0771C4.70792 12.2794 6.65207 13.3333 9.03679 13.3333C11.4215 13.3333 13.3657 12.2794 14.8062 11.0771C16.2447 9.87652 17.231 8.48809 17.7249 7.70596L17.745 7.67431C17.843 7.52003 17.9703 7.31971 18.0346 7.03903C18.0866 6.8124 18.0866 6.52093 18.0346 6.29431C17.9703 6.01362 17.843 5.8133 17.745 5.65902L17.7249 5.62737C17.231 4.84524 16.2447 3.45682 14.8062 2.25619C13.3657 1.05393 11.4215 0 9.03679 0ZM9.03679 3.33333C7.19584 3.33333 5.70346 4.82572 5.70346 6.66667C5.70346 8.50762 7.19584 10 9.03679 10C10.8777 10 12.3701 8.50762 12.3701 6.66667C12.3701 4.82572 10.8777 3.33333 9.03679 3.33333Z",
		fill: "#EAAA08"
	})]
});
export default SvgReviewerRoleIcon;
